export const radii = {
  card: "0.75rem",
};
